import React from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Typography from '@mui/material/Typography';
import ProjectCard from "../ProjectCard/ProjectCard";
import { portfolioData } from "./portfolioData";
import './Portfolio.scss';
import ProjectModal from "../ProjectModal/ProjectModal";
import { Link } from "react-router-dom";
import Card from "../ProjectCard/Card";

const Portfolio = () => {
    
    React.useEffect(() => {
        AOS.init();
        AOS.refresh();
    }, []);

    const [ isModalOpen, toggleModal ] = React.useState(false);
    const [ modalContent, setModalContent ] = React.useState({
        title:'',
        image:'',
        brief:'',
        description:[],
        code:'',
        demo:'',
        tech:[]
    });

    const openModal = () => {
        toggleModal(true);
    }

    const closeModal = () => {
        toggleModal(false);
    }

    const setModalData = (project) => {
        setModalContent(project);
    }

    return (
        <div id="portfolio">

            <div className="container">

                <Typography variant="h3" gutterBottom component="div" className="text-center main-heading">
                    Portfolio
                </Typography>
                <Typography variant="h6" gutterBottom component="div" className="text-center mini-heading">
                    Projects I have build
                </Typography>

                <ProjectModal 
                    modalContent={modalContent}
                    closeModal={closeModal}
                    isModalOpen={isModalOpen}
                 />

                <div className="portfolio-boxes">
                
                    {
                        portfolioData.slice(0,6).map((project, index) => (
                            <div 
                                key={index}
                                data-aos="fade-up" 
                                data-aos-delay={50*(index+1)}
                                data-aos-duration="900"
                                data-aos-easing="ease-in-out"
                            >
                                {/* <ProjectCard 
                                    project={project}
                                    openModal={openModal}
                                    setModalData={setModalData}
                                 /> */}

                                <Card 
                                    project={project}
                                    openModal={openModal}
                                    setModalData={setModalData}
                                 />
                            </div>
                        ))
                    }
                </div>

                <Typography variant="h6" gutterBottom component="div" className="text-center sub-heading">
                    <Link to="/projects" target="_blank">
                        <span>&lt;/</span> View More <span>&gt;</span>
                    </Link>
                </Typography>

            </div>
        </div>
    );
}

export default Portfolio;